

import $ from 'jquery';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';





jQuery(function(){

    let windowWidth = jQuery(window).width();


    const slider = new Swiper('.swiper-container', {
        loop: false, 
        spaceBetween: 20,
        slidesPerView: 1,   
        lazy: true, 
       // autoplay: {
        //  delay: 6000, // Autoplay delay in milliseconds
        //  disableOnInteraction: false, // Enable autoplay even after user interactions
        //},
        speed: 300, 
        navigation: {
            nextEl: '.slider__next',
            prevEl: '.slider__prev',
          },
          // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            767: {
                spaceBetween: 0,
            },
        },
        on: {
            init: function () {
                // Hide previous button initially
                document.querySelector('.slider__prev').style.transform = 'scale(0)';

            },
            slideChange: function () {
                var currentIndex = slider.activeIndex;

                // Hide all slides left of the current slide
                for (var i = 0; i < slider.slides.length; i++) {
                if (i < currentIndex) {
                    slider.slides[i].classList.add('swiper-slide--hidden');
                } else {
                    slider.slides[i].classList.remove('swiper-slide--hidden');
                }
                }

                if (this.isBeginning) {              
                document.querySelector('.slider__prev').style.transform = 'scale(0)';
                } else {
                document.querySelector('.slider__prev').style.transform = 'scale(1)';
                }

                if (this.isEnd) {
                document.querySelector('.slider__next').style.transform = 'scale(0)';
                } else {
                document.querySelector('.slider__next').style.transform = 'scale(1)';
                }
                  
            },
        }
    });

    // For speed reasons
    if (windowWidth < 1024){
        const uspSlider = new Swiper('.usp-slider', {
            loop: true, 
            spaceBetween: 0,
            slidesPerView: 1,
            lazy: true, 
            autoplay: {
              delay: 4000, // Autoplay delay in milliseconds
              disableOnInteraction: false, // Enable autoplay even after user interactions
            },
            speed: 300, 
        });
    }
   
});

    

